import { render, staticRenderFns } from "./tenderingfrm3.vue?vue&type=template&id=575011dd"
import script from "./tenderingfrm3.vue?vue&type=script&lang=js"
export * from "./tenderingfrm3.vue?vue&type=script&lang=js"
import style0 from "./tenderingfrm3.vue?vue&type=style&index=0&id=575011dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports